import React from 'react';
import LabelCard from './labelCard.jsx';

class LabelListComponent extends React.Component {

  render() {
    const { selectedLabels, ...otherProps} = this.props;
    const labelList = selectedLabels.map((label) => {
      return (
        <LabelCard
          {...otherProps}
          key={label.id}
          id={label.id}
          name={label.name}
          labelType={label.labelType}
          parentLabel={label.parentLabel} />
      );
    });
    return (
        <div className="EntityCard-List">{labelList}</div>
    );
  }

}

export default LabelListComponent;



// WEBPACK FOOTER //
// ./src/components/labelViewer/details/labelList.jsx